import React from "react"

const Time = ({ width = "24", height = "36", viewBox = "0 0 24 36" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.058 14.693a1.494 1.494 0 01-2.115 0l-4.635-4.636C5.363 9.113 6.038 7.5 7.373 7.5h9.255c1.335 0 2.01 1.613 1.065 2.557l-4.635 4.636zM18.75 28.5c.825 0 1.5.675 1.5 1.5v.75c0 .825-.675 1.5-1.5 1.5H5.25c-.825 0-1.5-.675-1.5-1.5V30c0-.825.675-1.5 1.5-1.5h13.5zm4.155-18.405A3.746 3.746 0 0024 7.447V3.75C24 1.68 22.32 0 20.25 0H3.75C1.68 0 0 1.68 0 3.75v3.697c0 .998.398 1.95 1.095 2.648l6.848 6.847c.585.585.585 1.53 0 2.116l-6.848 6.847A3.746 3.746 0 000 28.552v3.698C0 34.32 1.68 36 3.75 36h16.5c2.07 0 3.75-1.68 3.75-3.75v-3.698c0-.997-.397-1.95-1.095-2.647l-6.847-6.848a1.494 1.494 0 010-2.114l6.847-6.848z"
        fill="#DB1616"
      />
    </svg>
  )
}

export default Time